import { lazy } from 'react';
import { AdminIcon } from '@hf/designSystem/v1';
import type { SpaDefinition } from '@core/routes';
import { adminPaths } from './layout/adminPaths';

export { adminPaths };

const AdminLayout = lazy(async () => {
  const mod = await import('./layout/AdminLayout');
  return { default: mod.AdminLayout };
});
const AdminIndexRedirect = lazy(async () => {
  const mod = await import('./layout/AdminIndexRedirect');
  return { default: mod.AdminIndexRedirect };
});
const CompanyPage = lazy(async () => {
  const mod = await import('./pages/CompanyPage');
  return { default: mod.CompanyPage };
});

export const adminSpa = {
  key: 'admin',
  path: '/admin',
  label: 'Admin',
  icon: <AdminIcon />,
  public: false,
  nav: 'footer',
  adminOnly: true,
  trackRecent: true,
  paths: adminPaths,
  layout: <AdminLayout />,
  children: [
    { index: true, element: <AdminIndexRedirect /> },
    { path: adminPaths.company, element: <CompanyPage /> },
  ],
} as const satisfies SpaDefinition;
